import { Enum, EnumType } from 'ts-jenum';

@Enum<DynamicActionsBrickTypeEnum>('value')
export class DynamicActionsBrickTypeEnum extends EnumType<DynamicActionsBrickTypeEnum>() {
   static readonly UNKNOWN = new DynamicActionsBrickTypeEnum('unknown');
   static readonly BUTTONS = new DynamicActionsBrickTypeEnum('buttons');
   static readonly DROPDOWN = new DynamicActionsBrickTypeEnum('dropdown');

   private constructor(public value: string) {
      super();
   }
}
